import { useRef } from 'react';

import { getPlaceholderHtml as getPhonePlaceholderHtml } from '@components/field-mapping-phone-field/extensions';
import { Form } from '@components/form';
import { IconAddPlus } from '@components/icons/add-plus';
import { PopoverButton } from '@components/popover-button';
import { useScopedTranslate } from '@locale/translate';
import { pxToRem } from '@utils/converters';
import { formatPhoneNumber } from '@utils/strings';
import { uuid } from '@utils/uuid';

import { EditorRefProp } from '../common';
import { locale } from '../field-mapping-sidebar';

export const PhoneManualField = ({ editorRef }: EditorRefProp) => {
  const { t } = useScopedTranslate(locale);
  const fieldId = useRef(uuid()).current;
  return (
    <PopoverButton
      placement="bottom-start"
      triggerProps={{
        iconLeft: <IconAddPlus />,
        variant: 'secondary',
        text: t('addPhoneNumber'),
      }}
      contentStyle={{ maxWidth: pxToRem(392) }}
    >
      {({ close }) => (
        <Form
          onSubmit={(values) => {
            const value = values[fieldId];
            const label = formatPhoneNumber(value);
            if (value) {
              editorRef.current?.insertContent(getPhonePlaceholderHtml({ value, label }));
              close();
            }
          }}
        >
          <Form.PhoneField id={fieldId} label={t('core.phone')} portal />
          <Form.Actions>
            <Form.Reset text={t('core.cancel')} onClick={() => close()} />
            <Form.Submit
              variant="primary-blue"
              text={t('core.add')}
              iconLeft={<IconAddPlus style={{ opacity: 1 }} />}
            />
          </Form.Actions>
        </Form>
      )}
    </PopoverButton>
  );
};
